module.exports = new __parcel__URL__("mimetype-skeleton.tpl.8b750352.svg").toString();